import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=5f8ca304&"
import script from "./menuBar.vue?vue&type=script&lang=js&"
export * from "./menuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports